function contentDdm() {
    $('.ddm__content').dropDownMenu({
        disabled:    false,
        classBtn:    '',
        independent: true
    });
}
